import React, { useEffect } from "react";
import Instruction from "./Instruction";
import Button from "./Button";
import Childitem from "./Childitem";
import Childupload from "./Childupload";
import Header from "./Header";
import Childmodal from "./Childmodal";
import Fileupload from "./Fileupload";
import { useParams } from "react-router-dom";
import { Domain, Workspace } from "../../../path";
import { useState } from "react";
import usePost from "../../../Hooks/usePost";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../../Redux/Action/LoaderAction";

const Mainlayout = () => {
  const Dispatch = useDispatch();
  const { school_id, class_id } = useParams();
  const [ClassDetails, setClassDetails] = useState();
  const [Addchild, setAddchild] = useState({
    child_id: "",
    name: "",
    mobile: "",
    parent_name: "",
    gender: "",
    edit: false,
    std: "",
  });
  const [Modalbox, setModalbox] = useState({
    addchild: false,
    uploadchild: false,
  });
  const ClassDetailsData = usePost(
    `${Workspace[Domain].API_Path}/individual_class_children`
  );
  const Other_ClassDetailsData = usePost(
    `${Workspace[Domain].API_Path}/other_class_children`
  );

  const Get_ClassDetails = () => {
    ClassDetailsData.Postcall({
      school_id: atob(school_id),
      class_id: atob(class_id),
    });
  };
  const Get_otherClassDetails = () => {
    Other_ClassDetailsData.Postcall({
      school_id: atob(school_id),
    });
  };

  useEffect(() => {
    if (atob(class_id) != "other") {
      Get_ClassDetails();
    } else {
      Get_otherClassDetails();
    }
  }, [school_id, class_id]);
  useEffect(() => {
    return () => {
      setModalbox((prev) => ({ ...prev, addchild: false, uploadchild: false }));
    };
  }, []);

  useEffect(() => {
    if (ClassDetailsData.Post != null) {
      setClassDetails(ClassDetailsData.Post?.body);
      Dispatch(Set_Loader(false));
    }
  }, [ClassDetailsData?.Post]);
  useEffect(() => {
    if (Other_ClassDetailsData.Post != null) {
      setClassDetails(Other_ClassDetailsData.Post?.body);
      Dispatch(Set_Loader(false));
    }
  }, [Other_ClassDetailsData?.Post]);

  return (
    <div className="flex h-full items-start w-full relative">
      {/* RIGHT */}
      <div className="w-9/12 border-r-2 h-full max-[700px]:w-full max-[700px]:border-none">
        {/* SECTION HEADER */}
        <Header />

        <div className="min-[700px]:hidden">
          <Instruction show={true} />
        </div>

        {/* ANCHOR BUTTON HEADER */}
        <Childupload ClassDetails={ClassDetails} setModalbox={setModalbox} />

        {/* ANCHOR CHILD LIST */}
        <div
          className={`class-holder w-full flex px-2 flex-wrap ${
            ClassDetails?.list?.length ? "items-start" : "items-center"
          } justify-around min-[700px]:overflow-y-auto min-[700px]:h-[70%]`}
        >
          {/* ANCHOR CHILD ITEM */}
          {ClassDetails?.list?.length ? (
            ClassDetails?.list?.map((item, index) => {
              return (
                <Childitem
                  key={index}
                  item={item}
                  setAddchild={setAddchild}
                  setModalbox={setModalbox}
                />
              );
            })
          ) : (
            <p className="font-semibold text-[#ff0000]">No Child added</p>
          )}
        </div>

        {/* ANCHOR BUTTON SET */}
        <Button
          ClassDetails={ClassDetails}
          Get_ClassDetails={Get_ClassDetails}
          Get_otherClassDetails={Get_otherClassDetails}
        />
      </div>
      {/* ANCHOR LEFT */}
      <Instruction show={false} />
      {/* ANCHOR ADD CHILD / EDIT CHILD */}
      {Modalbox?.addchild && (
        <Childmodal
          setModalbox={setModalbox}
          Addchild={Addchild}
          setAddchild={setAddchild}
          Get_ClassDetails={Get_ClassDetails}
          Get_otherClassDetails={Get_otherClassDetails}
        />
      )}

      {/* ANCHOR UPLOAD CHILD MODAL */}

      {Modalbox?.uploadchild && (
        <Fileupload
          setModalbox={setModalbox}
          Childlist={
            atob(class_id) != "other" ? Get_ClassDetails : Get_otherClassDetails
          }
        />
      )}
    </div>
  );
};

export default Mainlayout;
